import { useEffect, useState } from 'react';
import io from 'socket.io-client';
import { config } from "../../services/config";
// import { ToastContainer, toast } from 'react-toastify';
import {toast} from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css';
import './toast.css'
import { api } from '../../services/api';
/* import { useAuth0 } from "@auth0/auth0-react"; */
import {useAuth} from "../context/AuthContext";

const socket = io(config.URL_SOCKET,{
  reconnection: true,
  reconnectionAttempts: 3,
  reconnectionDelay: 2000,
  reconnectionDelayMax: 600000,
  path:"/socket/",
}); // URL del servidor Socket.IO

function NotificacionComponent() {
  const { isAuthenticated } = useAuth();
  const [connected, setConnected] = useState(socket.connected); // el connected verifica si se establecio bien la conexion
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null)

  useEffect(() => {
    // Obtener el userId desde el endpoint
    const fetchUserId = async () => {
      try {
        const response = await api.usuarios.getUsuario();
        if (response.status === "success") {
          setUserId(response.data.usuario.id);
        }
      } catch (error) {
        console.error('Error al obtener el userId:', error);
      }
    };
    if (isAuthenticated) {
    fetchUserId();
  }
  }, [isAuthenticated]);

  useEffect(() => {
    if(userId){
      // escuchar el evento de conexion
      socket.on('connect', () => {
        setConnected(true); // cambiar el estado a conectado. si es que se conecta
        setError(null)

        //registrar el userId
        socket.emit('registrarUsuario', userId); //emitir el userid al servidor del socket
    });

    // manejar errores de conexion
    socket.on('connect_error', (err) =>{
      setError('No se pudo conectar al servidor..')
    })

    // manejar desconexion
    socket.on('disconnect', () => {
      setConnected(false)
    })

    socket.on('nueva-notificacion', (notification)=> {
      setNotifications(prevNotifications => [...prevNotifications, notification])
    
  })

    // limpiar la conexion al desmontar el componente
    return () => {
      socket.off('connect');
      socket.off('connect_error');
      socket.off('disconnect')
      socket.off('recconect')
      socket.off('nueva-notificacion');
    };
  }
  }, [userId]);

  useEffect(() => {
    if(connected && userId){
      socket.emit('registrarUsuario', userId);
    }
  }, [connected, userId]);

  return null;

  //ESTE JSX QUEDA PARA PRUEBAS NOMAS SI SE NECESITA MAS ADELANTE:
//   return (
//     <div>
//        {/* <ToastContainer /> */}
//       <h1>Cliente Socket.IO (prueba)</h1>
//       {connected ? (
//         <p style={{ color: 'green' }}>Conectado al servidor!</p>
//       ) : error ? (
//         <p style={{color: 'red'}}> {error} </p>
//       ):(
//         <p style={{ color: 'orange' }}>Conectando al servidor...</p>
//       )}
// {/* 
//   //     <div>
//   //       <h4>Notificaciones</h4>
//   //       <ul>
//   //         {notifications.length > 0 ? (
//   //           notifications.map((notification, i) => (
//   //             <li key={i}>{notification.titulo}</li>
//   //           ))
//   //         ) : (
//   //           <p>No hay notificaciones.</p>
//   //         )}
//   //       </ul>
//   //     </div> */}
//      </div>
//    );
}
export {socket};
export default NotificacionComponent;